import { default as React } from 'react';
import { connect } from 'react-redux';

export default function translate(Component) {
    class TranslationComponent extends React.Component {
        render() {
            var subset = this.props.strings[this.props.curLang];
            return <Component {...this.props} {...this.state} strings={subset} />;
        }
    }

    const mapStateToProps = (state) => {
        return {
            curLang: state.curLang,
            strings: state.uiStrings,
        };
    };
    return connect(mapStateToProps,null)(TranslationComponent);
}
